import createIcon from '../../createIcon';

/**
 * @component @name Download
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAyMC41SDE5VjE4LjVINVYyMC41Wk0xOSA5LjVIMTVWMy41SDlWOS41SDVMMTIgMTYuNUwxOSA5LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Download = createIcon('Download', [
  ['path', { d: 'M5 20.5H19V18.5H5V20.5ZM19 9.5H15V3.5H9V9.5H5L12 16.5L19 9.5Z', key: '456nu3' }],
]);

export default Download;
